export function formatDate (fmt, date) {
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

const fileUpDownTypes = {
  location: {
    type: 1,
    name: '区域'
  },
  equipment: {
    type: 2,
    name: '设备'
  },
  member: {
    type: 3,
    name: '人员'
  },
  material: {
    type: 4,
    name: '物料'
  },
  routing: {
    type: 5,
    name: '工艺路线'
  },
  process: {
    type: 6,
    name: '工序'
  },
  routingProcess: {
    type: 7,
    name: '工艺路线工序'
  },
  variate: {
    type: 8,
    name: '设备采集变量'
  },
  bom: {
    type: 9,
    name: 'bom'
  },
  materialType: {
    type: 10,
    name: '物料类型'
  },
  equipmentType: {
    type: 11,
    name: '设备类型'
  }
}



const dataMap = {
  unit: {
    m: '米',
    cm: '厘米',
    kg: '千克',
    g: '克',
    h: '时',
    M: '分',
    ge: '个',
    s: '秒',
    'ge/s': '个/秒'
  },
  uni_state: {
    '待审批': [0, 2],
    '通过': [1],
    '驳回': [2]
  },
  hasSons: {
    true: '是',
    false: '否'
  },
  qualityType: {
    1: '合格',
    2: '不合格',
    3: '报废'
  },
  ruleType: {
    1: '静态标识规则',
    2: '动态标识规则',
    3: '批次规则'
  },
  barcodeSource: {
    1: '菜单界面生成',
    2: '产出界面生成',
    3: '标识解析'
  },
  isFull: {
    false: '否',
    true: '是'
  },
  attrType: {
    '-1': '未知',
    1: '系统属性',
    2: '固定字符',
    3: '当前时间',
    4: '全局标识',
    5: '流水号',
    6: '随机字符'
  },
  useType: {
    1: '静态标识规则',
    2: '动态标识规则',
    3: '批次规则'
  },
  barcode_state: {
    0: '未打刻',
    1: '打刻成功',
    2: '打刻失败',
    3: '作废',
    4: '回收',
    5: '已下发'
  },
  enterprise_type: {
    1: '产品',
    2: '服务'
  }
}
const selectOptions = {
  productList: [
    {
      value: '1',
      label: '轮胎'
    },
    {
      value: '2',
      label: '齿轮'
    },
    {
      value: '3',
      label: '发动机'
    }
  ],
  barcode_state:[{
    label:'未打刻',
    value:'0'
  },{
    label:'打刻成功',
    value:'1'
  },{
    label:'打刻失败',
    value:'2'
  },{
    label:'作废',
    value:'3'
  },{
    label:'回收',
    value:'4'
  },{
    label:'已下发',
    value:'5'
  },
],
  codeTypeCode:[{
    label:'唯一码',
    value:'uniqueCode'
  },{
    label:'箱码',
    value:'boxCode'
  }],
  auditResult:[{
    label:'待审批',
    value:'待审批'
  },{
    label:'通过',
    value:'通过'
  },{
    label:'驳回',
    value:'驳回'
  }],
  qualityType: [{
    label: '合格',
    value: 1
  }, {
    label: '不合格',
    value: 2
  }, {
    label: '报废',
    value: 3
  }],
  format: [{
    label: 'yyyy',
    value: 'yyyy'
  }, {
    label: 'yyyyMM',
    value: 'yyyyMM'
  }, {
    label: 'yyyyMMdd',
    value: 'yyyyMMdd'
  }],
  ruleType: [{
    label: '静态标识规则',
    value: 1
  },
  //  {
  //   label: '动态标识规则',
  //   value: 2
  // },
   {
    label: '批次规则',
    value: 3
  }],
  capacityCheck: [{
    label: '不限制',
    value: 1
  }, {
    label: '提醒',
    value: 2
  }, {
    label: '限制',
    value: 3
  }],
  barcodeSource: [{
    label: '菜单界面生成',
    value: 1
  },
  //   {
  //   label: '产出界面生成',
  //   value: 2
  // },
    {
    label: '标识解析',
    value: 3
  }],
  quantity: [{
    label: '是',
    value: 0
  }, {
    label: '否',
    value: 1
  }]
}


const keyMap = {
  barcodeType: '标识类型',
  effectiveTime: '生效时间',
  isFull: '是否满容量',
  qualityType: '质量',
  quantity: '数量',
  traceAttr: '追溯属性',
  materialName: '物料名称',
  batchNo: '批次',
  materialCode: '物料编码',
  hasSons: '有子标识',
  parent: '父标识'
}

const taskOptions = {
  taskStatusOptions: [
    {
      stateName: "已处理",
      index: 1
    },
    {
      stateName: "待处理",
      index: 2
    },
    {
      stateName: "已撤销",
      index: 3
    }
  ],
  taskTypeOptions: [
    {
      taskTypeName: "码待批事项",
      taskTypeId: '1'
    },
    {
      taskTypeName: "码驳回事项",
      taskTypeId: '2'
    }
  ],
  enterpriseCapabilityOptions: [
    {
      name: '产品',
      type: 1,
    },
    {
      name: '服务',
      type: 2,
    }
  ]
}

export {
  dataMap,
  selectOptions,
  fileUpDownTypes,
  keyMap,
  taskOptions
}
